export default __webpack_public_path__ + "static/media/icon_calendar_16_Regular.6c878693.svg";